module.exports = __webpack_public_path__ + "img/purple.43baaa7d.svg";